"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = 'ffffffff-ffff-ffff-ffff-ffffffffffff';
